export const SUPPORTED_ANYTHING_TYPES = [
  'DATE',
  'DATETIME',
  'POSITION',
  'TEXT',
  'IMAGE_S3',
  'URL',
  'TIME',
  'IMAGE_URL',
  'LENGTH',
  'WEIGHT',
  'AUTHOR',
  'PRICE',
  'TEMPATURE',
  'LOCATION'
];
